// Copyright (c) 2016 Deere & Company

import {toggleAccordion} from './toggle-accordion';

export default {
    toggleAccordion
};



// WEBPACK FOOTER //
// ./src/shared/components/smart-accordion/action-creators/index.js